export default "__VITE_ASSET__BVlmllTY__"